import {Link} from '@primer/react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {MarkedAsDuplicateEvent$key} from './__generated__/MarkedAsDuplicateEvent.graphql'
import {TimelineRow} from './row/TimelineRow'
import {DuplicateIcon} from '@primer/octicons-react'

type MarkedAsDuplicateEventProps = {
  queryRef: MarkedAsDuplicateEvent$key
  issueUrl: string
  highlightedEventId?: string
  refAttribute?: React.MutableRefObject<HTMLDivElement | null>
}

export function MarkedAsDuplicateEvent({
  queryRef,
  issueUrl,
  highlightedEventId,
  refAttribute,
}: MarkedAsDuplicateEventProps): JSX.Element {
  const {actor, createdAt, canonical, databaseId} = useFragment(
    graphql`
      fragment MarkedAsDuplicateEvent on MarkedAsDuplicateEvent {
        actor {
          ...TimelineRowEventActor
        }
        createdAt
        canonical {
          ... on Issue {
            url
            number
          }
          ... on PullRequest {
            url
            number
          }
        }
        databaseId
      }
    `,
    queryRef,
  )

  const highlighted = String(databaseId) === highlightedEventId
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      leadingIcon={DuplicateIcon}
    >
      <TimelineRow.Main>
        {LABELS.timeline.markedAsDuplicate}
        <Link href={canonical?.url} sx={{color: 'fg.default', mx: 1}} inline>
          #{canonical?.number}
        </Link>
      </TimelineRow.Main>
    </TimelineRow>
  )
}

try{ MarkedAsDuplicateEvent.displayName ||= 'MarkedAsDuplicateEvent' } catch {}